export const SET_AUTH_CONTAINER_STATE = 'SET_AUTH_CONTAINER_STATE'

export const AUTH_CONTAINER_STATE_MAIN = 'AUTH_CONTAINER_STATE_MAIN'
export const AUTH_CONTAINER_STATE_VEHICLES = 'AUTH_CONTAINER_STATE_VEHICLES'
export const AUTH_CONTAINER_STATE_CARDS = 'AUTH_CONTAINER_STATE_CARDS'
export const AUTH_CONTAINER_STATE_SUCCESS = 'AUTH_CONTAINER_STATE_SUCCESS'
export const AUTH_CONTAINER_STATE_SUCCESS_BR = 'AUTH_CONTAINER_STATE_SUCCESS_BR'
export const AUTH_CONTAINER_STATE_FORGOT_PASSWORD = 'AUTH_CONTAINER_STATE_FORGOT_PASSWORD'
export const AUTH_CONTAINER_STATE_ADD_ACCOUNT_DETAILS = 'AUTH_CONTAINER_STATE_ADD_ACCOUNT_DETAILS'

export const LOGIN_INITIATE = 'LOGIN_INITIATE'
export const SIGNUP_FLOW_INITIATE = 'SIGNUP_FLOW_INITIATE'
export const SIGNUP_FLOW_ADD_VEHICLE = 'SIGNUP_FLOW_ADD_VEHICLE'
export const SIGNUP_FLOW_ERROR = 'SIGNUP_FLOW_ERROR'
export const SEND_PASSWORD_RESET_EMAIL = 'SEND_PASSWORD_RESET_EMAIL'
export const RESET_PASSWORD_SUCCESS = 'RESET_PASSWORD_SUCCESS'

export const RESET_SIGNUP_FLOW_STATE = 'RESET_SIGNUP_FLOW_STATE'
